import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6fe7e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_con" }
const _hoisted_2 = { class: "right_con" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin":"0"} }, "中午好 王金网店，忙碌了一上午，记得吃午饭哦", -1))
const _hoisted_4 = { class: "sub_title" }
const _hoisted_5 = { class: "demo" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "支付订单数（笔）", -1))
const _hoisted_9 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_11 = { class: "num" }
const _hoisted_12 = { style: {"padding-left":"20px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_14 = { style: {"font-size":"20px"} }
const _hoisted_15 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_17 = { style: {"font-size":"20px"} }
const _hoisted_18 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_20 = { style: {"font-size":"20px"} }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "header" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "支付金额（元）", -1))
const _hoisted_24 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_26 = { class: "num" }
const _hoisted_27 = { style: {"padding-left":"20px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_29 = { style: {"font-size":"20px"} }
const _hoisted_30 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_32 = { style: {"font-size":"20px"} }
const _hoisted_33 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_35 = { style: {"font-size":"20px"} }
const _hoisted_36 = { class: "item" }
const _hoisted_37 = { class: "header" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "商品数", -1))
const _hoisted_39 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_41 = { class: "num" }
const _hoisted_42 = { style: {"padding-left":"20px"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_44 = { style: {"font-size":"20px"} }
const _hoisted_45 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_47 = { style: {"font-size":"20px"} }
const _hoisted_48 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_50 = { style: {"font-size":"20px"} }
const _hoisted_51 = { class: "item" }
const _hoisted_52 = { class: "header" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "浏览量", -1))
const _hoisted_54 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_56 = { class: "num" }
const _hoisted_57 = { style: {"padding-left":"20px"} }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_59 = { style: {"font-size":"20px"} }
const _hoisted_60 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_62 = { style: {"font-size":"20px"} }
const _hoisted_63 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_65 = { style: {"font-size":"20px"} }
const _hoisted_66 = { class: "item" }
const _hoisted_67 = { class: "header" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "累计客户数", -1))
const _hoisted_69 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_71 = { class: "num" }
const _hoisted_72 = { style: {"padding-left":"20px"} }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_74 = { style: {"font-size":"20px"} }
const _hoisted_75 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_77 = { style: {"font-size":"20px"} }
const _hoisted_78 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_80 = { style: {"font-size":"20px"} }
const _hoisted_81 = { class: "item" }
const _hoisted_82 = { class: "header" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "可用店铺余额", -1))
const _hoisted_84 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_86 = { class: "num" }
const _hoisted_87 = { style: {"padding-left":"20px"} }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_89 = { style: {"font-size":"20px"} }
const _hoisted_90 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_92 = { style: {"font-size":"20px"} }
const _hoisted_93 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_95 = { style: {"font-size":"20px"} }
const _hoisted_96 = {
  id: "mycharts",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"450px"}
}
const _hoisted_97 = {
  id: "mycharts2",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"450px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_countTo = _resolveComponent("countTo")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { class: "home" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_avatar, {
            size: 70,
            style: {"backgroundColor":"#87d068"}
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_UserOutlined)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, "更新时间" + _toDisplayString(_ctx.updata_time), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.order_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.order_num.yesterday), 1),
              (_ctx.order_num.change_add>0 || _ctx.order_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.order_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.order_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.order_price.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", null, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.order_price.yesterday), 1),
              (_ctx.order_price.change_add>0 || _ctx.order_price.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.order_price.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order_price.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.order_price.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.add_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", null, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.add_user_num.yesterday), 1),
              (_ctx.add_user_num.change_add>0 || _ctx.add_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.add_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.add_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.add_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_55
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.visit_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", null, [
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.visit_user_num.yesterday), 1),
              (_ctx.visit_user_num.change_add>0 || _ctx.visit_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.visit_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_70
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.visit_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", null, [
              _hoisted_73,
              _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.visit_user_num.yesterday), 1),
              (_ctx.visit_user_num.change_add>0 || _ctx.visit_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                    _hoisted_76,
                    _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.visit_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("div", _hoisted_84, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_85
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_86, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.visit_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", null, [
              _hoisted_88,
              _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.visit_user_num.yesterday), 1),
              (_ctx.visit_user_num.change_add>0 || _ctx.visit_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.visit_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                    _hoisted_94,
                    _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_card, {
      title: "近30天营业额",
      style: {"margin-top":"20px","height":"600px","width":"49%","float":"left"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_96, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "近30天营业额",
      style: {"margin-top":"20px","height":"600px","width":"49%","float":"right"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_97, null, 512)
      ]),
      _: 1
    })
  ]))
}